import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CORE_CONFIG, CoreModuleConfig } from './model/core-module-config';

@NgModule({
  imports: [CommonModule]
})
export class CoreModule {
  static withConfig(config: CoreModuleConfig): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [{ provide: CORE_CONFIG, useValue: config }],
    };
  }
}
